import React from 'react';
import { Flex } from '../Flex/Flex';
import { Arrow } from './Arrow';
import { AbsoluteTransformLeft } from './Arrow.styled';
export function TopArrows({
  arrowPosition,
  arrowProps
}) {
  const isSide = arrowPosition === 'side';
  const Wrapper = isSide ? AbsoluteTransformLeft : Flex;
  return ['top', 'side'].includes(arrowPosition) ? React.createElement(Wrapper, {
    justifyContent: 'flex-end',
    pb: isSide ? 0 : 2,
    zIndex: 1,
    "data-testid": isSide ? 'side-left-arrow' : 'top-arrows'
  }, React.createElement(Arrow, {
    isLeft: true,
    ...arrowProps
  }), isSide ? null : React.createElement(Arrow, {
    ...arrowProps,
    ml: 3
  })) : null;
}